/**
 * iter83 - Fire-and-forget page-view tracker. Mounts at the app root,
 * emits one POST /api/telemetry/page per route change.
 *
 * Never blocks navigation. Failures are swallowed silently.
 * Never stores: referrer, IP, full UA. See admin_analytics.record_event().
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function TelemetryProvider({ children }) {
  const loc = useLocation();
  useEffect(() => {
    const isMobile = /mobile|android|iphone|ipad|ipod/i.test(navigator.userAgent || "");
    // Fire-and-forget. No await, no toast on failure.
    api.post("/telemetry/page", {
      path: loc.pathname,
      event_type: "page_view",
      is_mobile: isMobile,
    }).catch(() => {});
  }, [loc.pathname]);
  return children;
}
